import { datepickerCalendarCellButtonClassName } from '../../../../components/Datepicker/DatepickerCalendarCellButton';
export var datepickerCalendarGridRowStyles = {
  root: function root(_ref) {
    var _ref2;

    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({}, p.isRowSelectionActive && (_ref2 = {}, _ref2[":hover ." + datepickerCalendarCellButtonClassName] = {
      backgroundColor: v.calendarCellHoverBackgroundColor,
      color: v.calendarCellHoverColor
    }, _ref2));
  }
};
//# sourceMappingURL=datepickerCalendarGridRowStyles.js.map
